<template>
    <div class="flex h-full w-full">
        <div class="fixed w-full h-full bg-gray-200 opacity-80" v-if="winningPlayers.filter(i => i.name == '').length > 0"></div>
        <div class="fixed flex w-full h-full items-center justify-center" v-if="winningPlayers.filter(i => i.name == '').length > 0">
            <div class="bg-white p-6 flex flex-col space-y-4">
                <div>{{ winningPlayers.filter(i => i.name == '')[0]?.gamer }} Numaralı oyuncunun adını yazınız.</div>
                <div class="flex space-x-2">
                    <input class="border border-black p-2" type="text" v-model="gamer_name" placeholder="Adınız">
                    <button class="bg-secondary rounded-lg px-2 text-white" @click="setGamerName">Kaydet</button>
                </div>
            </div>
        </div>

        <div class="flex flex-col space-y-6 w-full h-full items-center justify-center">
            <div class="p-4 h-32 flex space-x-2">
                <div class="py-3 px-6 rounded-lg flex flex-col justify-between" :class="state == 'first_gamer' ? 'bg-secondary text-white':'bg-gray-300'">
                    <div class="h-full flex items-center justify-center text-2xl">{{ first_gamer ? (getGamerName(first_gamer) || first_gamer) :'-' }}</div>
                    <div class="text-xs">1. Oyuncu (X)</div>
                </div>
                <div class="py-3 px-6 rounded-lg flex flex-col justify-between" :class="state == 'second_gamer' ? 'bg-primary-default text-white':'bg-gray-300'">
                    <div class="h-full flex items-center justify-center text-2xl">{{ second_gamer ? (getGamerName(second_gamer) || second_gamer) :'-' }}</div>
                    <div class="text-xs">2. Oyuncu (O)</div>
                </div>
            </div>
            <div class="mb-4 text-secondary h-6">
                {{ getState() }}
            </div>
            <div class="flex flex-wrap w-64 h-64">
                <div class="w-1/3" v-for="g,key in gameBoard" :key="key">
                    <div
                        class="w-20 h-20 rounded-lg flex items-center justify-center font-bold text-2xl"
                        :class="setClassBoard(g, key)"
                        @click="setAnswer(key)"
                    >
                        {{ g }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script setup>
import {ref, onMounted, defineProps, watch} from 'vue'
import useSound from '../../sounds'
import useRandIndex from '../../compositions/useRandIndex'
const {selectedIndexError, select, selectingIndex, getRandomSelectIndex, excludedIndexes, selectableLength, selectableSize, selectableIndexes} = useRandIndex()

const props = defineProps(["classSize", "isStart", "volume", "files_url"])
const emit = defineEmits(["is_start", "winners"])
const gameBoard = ref(["","","","","X","O","","",""])
const winningPlayers = ref([])
const lastWinning    = ref(null)
const state          = ref(null)
const first_gamer    = ref(null)
const second_gamer   = ref(null)
const wait           = ref(false)
const {soundStart, soundSetVolume} = useSound({files_url:props.files_url})
const gamer_name     = ref(null)
const isStart        = ref(props.isStart)
const winningSquares = ref([])
const tieCount       = ref(0)
const maxTie         = ref(3)

onMounted(() => initializeGame())


watch(props, (cProps) => {
    soundSetVolume(cProps.volume)
    isStart.value = cProps.isStart
}, {deep: true, immediate: true})


watch(isStart, (cIsStart) => {
    selectableLength.value = props.classSize
    selectableSize.value   = 2
    if (cIsStart) startGame()
})

watch(winningPlayers, (cWinning) => {
    emit('winners', cWinning)
},{deep: true})


watch(lastWinning, (cLastWinning) => {
    if (cLastWinning) {
        let winning = lastWinning.value == 'first_gamer' ? first_gamer.value : second_gamer.value
        excludedIndexes.value = [winning - 1]
        selectableSize.value   = 1
    }else{
        excludedIndexes.value = []
        selectableSize.value  = 2
    }
})

watch(tieCount, (cTieCount) => {
    if (cTieCount == maxTie.value) {
        lastWinning.value = null
        tieCount.value = 0
    }
})

//oyun başlangıç ayarları
const initializeGame = () => {
    emit('is_start', false)
    gameBoard.value         = ["","","","","","","","",""]
    winningPlayers.value    = []
    lastWinning.value       = null
    state.value             = null
    first_gamer.value       = null
    second_gamer.value      = null
}

const startGame = () => {
    emit('is_start', true)
    selectGamer()
}


const setAnswer = (index) => {
    soundStart(2)
    if (!(state.value == "first_gamer" || state.value == "second_gamer")) return false
    if (gameBoard.value[index] != "") return false
    if (wait.value) return false

    let selectText = "O"
    let selectState = "first_gamer"
    if (state.value == "first_gamer") {
        selectText = "X"
        selectState = "second_gamer"
    }

    state.value = selectState
    gameBoard.value[index] = selectText
    checkAnswer(selectText)
}


const checkAnswer = (selectText) => {
    let victoryArray = [
        [0,1,2],
        [0,3,6],
        [0,4,8],
        [1,4,7],
        [2,5,8],
        [2,4,6],
        [3,4,5],
        [6,7,8]
    ]

    let result = victoryArray.filter(i => {
        if (gameBoard.value[i[0]] == selectText && gameBoard.value[i[1]] == selectText && gameBoard.value[i[2]] == selectText) {
            winningSquares.value = [i[0], i[1], i[2]]
            return true
        }
    })


    //birisi kazandı demektir
    if (result.length > 0) {
        tieCount.value = 0

        if (selectText == "X") lastWinning.value = 'first_gamer'
        if (selectText == "O") lastWinning.value = 'second_gamer'

        let winningGamerIndex = lastWinning.value == 'first_gamer' ? first_gamer.value : second_gamer.value
        let newGamer = {
            gamer: winningGamerIndex,
            count: 1,
            name: ""
        }

        let checkedWinningIndex = winningPlayers.value.findIndex(i => i.gamer == winningGamerIndex);
        if (checkedWinningIndex == -1) {
            winningPlayers.value = [...winningPlayers.value, newGamer]
        }else{
            winningPlayers.value[checkedWinningIndex].count++
        }


        //4 saniye sonra yeni oyun başlat
        wait.value = true
        state.value = selectText == "X" ? 'first_gamer_win' : 'second_gamer_win'
        soundStart(0)
        setTimeout(() => selectGamer(), 4000);
        return false
    }

    //oyun berabere bitti demektir
    if (gameBoard.value.filter(i => i == "").length == 0) {
        if (lastWinning.value) tieCount.value += 1

        state.value = 'game_draw_ended'
        wait.value = true

        soundStart(1)
        setTimeout(() => selectGamer(), 3000);
        return false
    }


}


const selectGamer = () => {
    winningSquares.value = []
    soundStart(4)
    wait.value = false
    gameBoard.value = ["","","","","","","","",""]
    state.value = "select_gamer"
    let i = 0

    if (props.classSize < 3) {
        if (lastWinning.value != 'first_gamer') first_gamer.value = 1
        if (lastWinning.value != 'second_gamer') second_gamer.value = 2
        state.value = lastWinning.value || "first_gamer"
        return false
    }

    select()

    const interval = setInterval(() => {
        const randomSelectIndex = getRandomSelectIndex();

        if (lastWinning.value) {
            if (lastWinning.value != 'first_gamer') first_gamer.value = randomSelectIndex[0] + 1
            if (lastWinning.value != 'second_gamer') second_gamer.value = randomSelectIndex[0] + 1
        }else{
            first_gamer.value = randomSelectIndex[0] + 1
            second_gamer.value = randomSelectIndex[1] + 1
        }



        if(i == 5) {
            state.value = lastWinning.value || "first_gamer"
            if (lastWinning.value) {
                if (lastWinning.value != 'first_gamer') first_gamer.value = selectingIndex.value[0] + 1
                if (lastWinning.value != 'second_gamer') second_gamer.value = selectingIndex.value[0] + 1
            }else{
                first_gamer.value = selectingIndex.value[0] + 1
                second_gamer.value = selectingIndex.value[1] + 1
            }

            clearInterval(interval)
        }
        i++
    }, 600);
}


const getState = () => {

    let newWininigGamer = lastWinning.value == 'first_gamer' ? first_gamer.value : second_gamer.value
    const s = {
        select_gamer: 'Oyuncu Seçiliyor.',
        first_gamer: !getGamerName(first_gamer.value) ? 'Sıra birinci oyuncuda.' : `Sıra ${getGamerName(first_gamer.value)} isimli oyuncuda`,
        second_gamer: !getGamerName(second_gamer.value) ? 'Sıra ikinci oyuncuda.' : `Sıra ${getGamerName(second_gamer.value)} isimli oyuncuda`,
        first_gamer_win: !getGamerName(newWininigGamer) ? `${newWininigGamer} Numaralı Oyuncu Kazandı.` : `${getGamerName(newWininigGamer)} kazandı`,
        second_gamer_win: !getGamerName(newWininigGamer) ? `${newWininigGamer} Numaralı Oyuncu Kazandı.` : `${getGamerName(newWininigGamer)} kazandı`,
        game_draw_ended: `Oyun Berabere bitti.`,
    }
    return s[state.value]
}

const setClassBoard = (char, key) => {
    let bg = 'bg-yellow-300'
    let style = {
        X: 'text-secondary',
        O: 'text-primary-default'
    }

    if (winningSquares.value.length > 0 && !winningSquares.value.includes(key)) {
        bg = 'bg-gray-300'
    }

    return `${style[char]}  ${bg}`
}


const setGamerName = () => {
    let selectGamer = winningPlayers.value.filter(i => i.name == '')[0]
    let gamerIndex  = winningPlayers.value.findIndex(i => i.gamer == selectGamer.gamer)

    winningPlayers.value[gamerIndex].name = gamer_name.value
    setTimeout(() => gamer_name.value = "", 1000);
}


const getGamerName = (index) => {
    let gamerIndex  = winningPlayers.value.findIndex(i => i.gamer == index)
    if (gamerIndex == -1) return false

    return winningPlayers.value[gamerIndex].name
}



</script>
